import React from 'react';
import RadioCheckbox from './../forms/RadioCheckbox';
import SelectOccupationRating from './../forms/SelectOccupationRating';
import RadioToggle from './../forms/RadioToggle';
import GetHelp from './../forms/GetHelp';
import classnames from 'classnames';

class SelectRiskRating extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };

    this.handleChange = this.handleChange.bind(this);    
  }

  handleChange(e) {
    if (this.props.onChange) {
			this.props.onChange(e.target.value);
		}
    // this.props.onChange(this.props.id, e.target.value);
    this.setState({
      active: e.target.value
    });
  }

  render() {

    let nodes = this.props.items.map((items, index) => {
      return (
      <li key={index}>
        <input
          id={this.props.name + index}
          className={classnames(items.class, { active: this.state.active == items.value})}
          type="radio"
          onChange={this.handleChange}
          value={items.value}
          name={this.props.name}
          defaultChecked={items.defaultChecked}
        />
        <label htmlFor={this.props.name + index}>{items.label}</label>
      </li>
    );
    });

    return (
      <span>
        <ul className="tabs">
          {nodes}
        </ul>

      </span>
    );
  }
}

SelectRiskRating.defaultProps = {
    items: [
      {value: 0, label: "Complete our occupational rating questionnaire", defaultChecked: false},
      {value: 1, label: "Select your QSuper occupational rating", defaultChecked: false}
    ]
};

SelectRiskRating.propTypes = {
  items: React.PropTypes.array.isRequired,  
  onChange: React.PropTypes.func.isRequired,
  name: React.PropTypes.string.isRequired
};

export default SelectRiskRating;



// WEBPACK FOOTER //
// ./src/components/forms/SelectRiskRating.js